// @flow

import FioInput from './fio-input';
import { default as FioInputTemplate } from './templates/index.html';

export const COMPONENTS_FIO_INPUT_NAME = 'fio-input';

export const COMPONENTS_FIO_INPUT_ENTITIES = [
	{
		name: COMPONENTS_FIO_INPUT_NAME,
		entity: FioInput,
		template: FioInputTemplate,
	},
];
